import axios from 'axios';
import type { GetSimpleListingsByIdsDTO } from '@/app-package';

const getSimpleListings = async (ids: string[]) => {
  const {
    data: { listings },
  } = await axios.get<GetSimpleListingsByIdsDTO>(`/listing/simpleListings`, {
    params: { lids: ids },
  });

  return listings;
};
export default getSimpleListings;
